import React, {Fragment, useEffect, useRef, useState} from 'react'
import axios, * as others from 'axios';
import {Link, useLoaderData, useLocation, useParams} from "react-router-dom";
import {
    addEventAttribute,
    adminVenueCard,
    audienceButtons,
    changeAttribute,
    getAttribute,
    getImageWithPrefix,
    getLocalDate,
    hasAttribute, imagePad,
    manageVenueData,
    MetaTags,
    setAttribute,
    setRoomAttribute,
    setUniqueEventAttribute,
    setUniqueVenueAttribute,
    smallArtistCard,
    smallEventCard,
    smallVenueCard,
    toastSuccess
} from "../../components/common/utilities";
import ContentEditable from "react-contenteditable";
import PropertyNavigation from "../../components/common/navigation.component";
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader'
import MainNavigation from "../../components/common/navigation.component";
import {DateTimePicker, LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment'
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import 'moment/locale/en-gb';
import SidebarNavigation from "../../components/common/sidebarnavigation.component";
import MediaCollection from "../media/mediaCollection";
import {Dialog, Field, Label, Switch, Transition} from "@headlessui/react";
import mapboxgl from "mapbox-gl";
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import {ChevronRightIcon} from "@heroicons/react/20/solid";
import Map, {GeolocateControl, Marker} from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import metaDataLinks from "../../components/common/metaDataLinks";
import {XMarkIcon} from "@heroicons/react/24/outline";
import NLPPrompt from "../nlp/nlpprompt";
import {SchemaEvent} from "../../components/common/dataTypes";
import {ToastContainer} from "react-toastify";
import EditDescriptions from "../../components/common/editdescriptions";
import ListActionItems from "../../components/actionitems/listActionItems";

function classNames(...classes: any[])
{
    return classes.filter(Boolean).join(' ')
}

export default function ViewVenue() {
    let params = useParams();
    const venueID = params.venueID;
    const data = useLoaderData() as any;
    //console.log("params", params);



    const text = useRef("");
    const inFocus = useRef("");
    const [artists, setArtists] = useState(data.artists);
    const [photos, setPhotos] = useState([]);
    let [loading, setLoading] = useState(true);
    let [color, setColor] = useState("#ffffff");
    const [date, setDate] = useState(null)
    const [venueData, setVenueData] = useState<SchemaEvent>();
    const [eventList, setEventList] = useState([]);
    const [showMedia, setShowMedia] = useState(false);
    const [wholeDay, setWholeDay] = useState(false);
    const [lang, setLang] = useState(getLang());
    const [open, setOpen] = useState(false);
    const [showAI, setShowAI] = useState(false);
    const [showDescriptions, setShowDescriptions] = useState(false);



    function getLang()
    {
        if (navigator.languages != undefined) return navigator.languages[0];
        return navigator.language;
    }

    mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

    const getVenue = () => {

        let now = new Date();

        let parameters = {
            instance: 'promogogo',
            ticket: localStorage.getItem('ticket'),
            venue: params.venueid,
            light: true,
            lang: lang,
            start: now.toISOString(),
        };
        if (data.isAdmin)
        {
            parameters['admin'] = true;
        }

        axios.get(`${process.env.REACT_APP_API_URL}/p/manage/venue.do`, {
            params: parameters

        }).then(function (response) {
            // handle success
            //console.log(response);
            setVenueData(response.data)
            if (response.data.geo && response.data.geo.latitude)
            {
                mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;
                setTimeout(() => renderMap(response.data.geo.latitude, response.data.geo.longitude), 1000);
            }
            else {
                mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;
                setTimeout(() => renderMap(64.1479, -21.9426), 1000);
            }
            console.log("venueData", venueData);


        });
    }

    const saveVenue = (e) => {
        e.preventDefault();
        console.log(e);

        console.log('posting ', venueData);
        /*axios.post(`${process.env.REACT_APP_API_URL}/p/manage/venue/create.do`, venueData, {}).then(function (response) {
            // handle success
            console.log(response);
            setVenueData(response.data);
            //setOpen(false);
            //setRooms(response.data.collection);
            //window.location.href = '/onboarding/room/'+response.data.collection[0]['guid'];

        });*/
    }


    const getEvents = nextOffset => {
        axios.get(`${process.env.REACT_APP_API_URL}/p/events/upcoming.do`, {
            params: {
                instance: 'promogogo', ticket: localStorage.getItem('ticket'), //guid: params.id,
                limit: 10, offset: nextOffset, venue: params.venueid, light: true
            }

        }).then(function (response) {
            // handle success
            console.log("events", response);
            setEventList(response.data.collection);

        });
    }

    const toggleMedia = () => {
        setShowMedia(!showMedia);
    }

    const getAddress = (longitude,latitude) => {
        axios.get('https://api.mapbox.com/search/geocode/v6/reverse', {
            params: {
                access_token: process.env.REACT_APP_MAPBOX_TOKEN,
                types: 'address',
                longitude: longitude,
                latitude: latitude,
                limit: 1
            }
        }).then(function (response) {
            // handle success
            //console.log(response);
            let location = response.data;
            console.log(location);
            if (location.features && location.features.length > 0 && location.features[0] && location.features[0].properties)
            {
                let address = location.features[0].properties.context;
                console.log(address);
                let newVenuedata = {
                    ...venueData, address: {

                        streetAddress: address.address.name,
                        addressLocality: address.locality.name,
                        addressRegion: address.region.name,
                        addressCountry: address.country.name
                    }
                }
                setVenueData(newVenuedata);

            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        });
    }

    const changeLocation = (longitude, latitude) => {
        console.log('changing location: ' + longitude + " " + latitude);

        console.log('venuedata', venueData);

        if(venueData)
        {
            setVenueData({
                             ...venueData, geo: {
                    "@type": "GeoCoordinates",
                    latitude: latitude, longitude: longitude
                }});
        }
        if(latitude && longitude)
        {
            axios.post (`${process.env.REACT_APP_API_URL}/p/manage/venue/data/change.do`, {
                instance: 'promogogo',
                ticket: localStorage.getItem('ticket'),
                venue: params.venueid,
                type: 'geolocation',
                latitude: latitude,
                longitude: longitude

            },{
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(function (response) {
                // handle success
                console.log(response);
                //setVenueData(response.data);
                //getAddress(longitude,latitude);
            }).catch(function (error) {
                // handle error
                console.log(error);
            });
        }




    }

    const renderMap = (latitude, longitude) => {
        const map = new mapboxgl.Map({
                                         container: 'map',
                                         style: 'mapbox://styles/mapbox/streets-v12',
                                         center: [longitude, latitude],
                                         zoom: 14,
                                         interactive: true,


                                     });
        map.on('click', function (e) {
            var coordinates = e.lngLat;

            //console.info('map clicked', coordinates)
            startMarker.setLngLat([coordinates.lng, coordinates.lat]);
            changeLocation(coordinates.lng, coordinates.lat);
            /*new mapboxgl.Popup()
                .setLngLat(coordinates)
                .setHTML('you clicked here: <br/>' + coordinates)
                .addTo(map);*/
        });
        const startMarker = new mapboxgl.Marker()
            .setLngLat([longitude, latitude])
            .addTo(map);

        const geocoder = new MapboxGeocoder({ accessToken: mapboxgl.accessToken,
                                                mapboxgl: mapboxgl,
                                                container: 'map',
                                                marker: true,
                                                zoom: 14,
                                                placeholder: 'Search for a venue',
                                                limit: 5
                                            } );
         var elementgeocoder = document.getElementById('geocoder');
         if(elementgeocoder && !elementgeocoder.hasChildNodes()){
             elementgeocoder.appendChild(geocoder.onAdd(map));
         }

    }


    useEffect(() => {

        getVenue();
        getEvents(0);
        //getPhotos();
        //handleArtists(data);

    }, []);

    const pagedata = useLoaderData() as any;
    let faceguid = '';

    function clickedEvent(e)
    {
        console.log("clicked", e.target);

        let button = e.target.dataset.button;
        if (button === 'mediaSelected')
        {
            console.log('settingMedia');
            let media = e.target.dataset.media;
            setVenueData({
                             ...venueData, image: media
                         });


            let key = "bestimage";
            let value = e.target.dataset.value;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = venueData['@id'];

            manageVenueData(key,media,eventid);

            toastSuccess('Venue updated');

        }
        else if (button === 'setPrivate')
        {
            console.log('setting private');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueVenueAttribute(key, value, unique, remove, eventid);

            toastSuccess('Event set to private');

        }

        else if (button === 'manageAudience')
        {
            console.log('managing audience');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = true;
            let remove = e.target.dataset.remove;
            let eventid = venueData['@id'];

            setUniqueVenueAttribute('pgg.audience.' + key, 'pgg.audience.' + value, unique, remove, eventid);

            toastSuccess('Audience set ' + key + ' Remove: ' + remove);

        }


    }

    function onSelected(viewport: any)
    {

        console.log('on Selected', viewport);
        setVenueData({
                         ...venueData, geo: {
                latitude: viewport.latitude, longitude: viewport.longitude
            }
                     });
    }

    const showAIprompt = () => {
        setShowAI(true);
        setOpen(true);
    }
    const editDescriptions = () => {
        setOpen(true);
        setShowAI(false);
        setShowDescriptions(true);
    }

    return (

        <div className="min-h-full dark:bg-white bg-white">
            <MetaTags
                title={venueData && venueData.name}
                description={venueData && venueData.description}
                image={venueData && venueData.image}/>
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-40" onClose={setOpen}>
                    <div className="fixed inset-0"/>

                    <div className="fixed inset-0 overflow-hidden">
                        <div className="absolute inset-0 overflow-hidden">
                            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-2">
                                <Transition.Child
                                    as={Fragment}
                                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                                    enterFrom="translate-x-full"
                                    enterTo="translate-x-0"
                                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                                    leaveFrom="translate-x-0"
                                    leaveTo="translate-x-full"
                                >
                                    <Dialog.Panel className="pointer-events-auto w-screen max-w-2xl">
                                        <div
                                            className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
                                            <div
                                                className="flex min-h-0 flex-1 flex-col overflow-y-scroll overflow-x-hidden py-1">
                                                <div className="px-2 sm:px-6">
                                                    <div className="flex items-start justify-between">
                                                        <Dialog.Title
                                                            className="text-base font-semibold leading-6 text-gray-900">
                                                            Details
                                                        </Dialog.Title>
                                                        <div className="ml-3 flex h-7 items-center">
                                                            <button
                                                                type="button"
                                                                className="relative rounded-md bg-red-700 text-white hover:bg-red-500 hover:outline-none hover:ring-2 hobver:ring-red-500"
                                                                onClick={() => setOpen(false)}
                                                            >
                                                                <span className="absolute -inset-2.5"/>
                                                                <span className="sr-only">Close panel</span>
                                                                <XMarkIcon className="h-6 w-6" aria-hidden="true"/>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="relative mt-6 flex-1 px-4 sm:px-6"
                                                     onClick={event => clickedEvent(event)}>
                                                    {venueData && showAI && <NLPPrompt theData={venueData}/>}
                                                    {showDescriptions && <EditDescriptions theData={venueData} event={false} artist={false} venue={venueData['@id']}/>}

                                                </div>
                                            </div>
                                            <div className="flex flex-shrink-0 justify-end px-4 py-4">
                                                <button
                                                    type="button"
                                                    className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400"
                                                    onClick={() => setOpen(false)}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
            <SidebarNavigation/>
            <div className="lg:pl-72">

                <main>

                    <div className="grid sm:grid-cols-3 gap-4">
                        <div className="col-span-2">
                            <div className="mt-2">
                                {!venueData && <div className="p-4 text-gray-800 flex justify-center">
                                    <div className={'text-pg_yellow'}><i
                                            className="fa-2x fa-duotone fa-loader fa-spin"></i></div>
                                </div>}
                                {venueData && <>
                                    <div className="">
                                        <div className="px-4 py-5 sm:p-6">
                                            <div className=" px-4 sm:mt-16 sm:px-0 lg:mt-0">
                                                <form>
                                                    <label htmlFor="value"
                                                           className="text-1xl font-bold tracking-tight text-gray-900">
                                                        Title
                                                    </label>
                                                    <div className="mt-2 flex rounded-md shadow-sm h-10">
                                                        <div
                                                                className="relative flex flex-grow items-stretch focus-within:z-10">
                                                            <div
                                                                    className="p-2 pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">

                                                            </div>
                                                            <input
                                                                    type="text"
                                                                    name="value"
                                                                    id="value"
                                                                    className="block w-full rounded-none rounded-l-md border-0 py-1.5 pl-2 ring-1 ring-inset ring-gray-300  focus:ring-2 focus:ring-inset focus:ring-indigo-600  text-3xl font-bold tracking-tight text-gray-900"
                                                                    defaultValue={venueData.name}
                                                            />
                                                        </div>
                                                        <button
                                                                type="submit"
                                                                className="relative -ml-px inline-flex items-center gap-x-1.5 rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                                        >

                                                            Save
                                                        </button>
                                                    </div>

                                                </form>

                                                {venueData.description && <div className="mt-4"
                                                                               dangerouslySetInnerHTML={{__html: venueData.description}}></div>}

                                                <button onClick={() => showAIprompt()}
                                                        className={'relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10'}>AI
                                                    Prompt
                                                </button>
                                                <button onClick={() =>editDescriptions()}
                                                        className={'relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10'}>
                                                    Descriptions
                                                </button>
                                                <a href={'/venue/' + venueData['@id'] + '/merge'}
                                                   rel="noopener noreferrer">
                                                    <button className={'relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10'}>Merge</button>
                                                </a>
                                                {data.isAdmin && <>
                                                {venueData && !hasAttribute(venueData,'pgg.parent.kirkjan') && <><button
                                                        onClick={() => setUniqueVenueAttribute('pgg.parent.kirkjan', 'pgg.parent.kirkjan', true, false, venueData['@id'])}
                                                        className={'relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10'}>Set as Church</button></>}
                                                {venueData && hasAttribute(venueData,'pgg.parent.kirkjan') && <><button
                                                        onClick={() => setUniqueVenueAttribute('pgg.parent.kirkjan', 'pgg.parent.kirkjan', true, true, venueData['@id'])}
                                                        className={'relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10'}>Is Church</button></>}
                                                </>}
                                                </div>
                                            <div className=" px-4 sm:mt-16 sm:px-0 lg:mt-4">
                                                <a href={`${process.env.REACT_APP_API_URL}/go/editvenue.do#!/venue/` + venueData['@id']}
                                                   target={'_blank'} rel="noopener noreferrer"
                                                   className="relative flex items-center space-x-3 rounded-lg border border-gray-300 bg-white shadow-sm  hover:border-gray-400 mb-3"
                                                >
                                                    <div className="flex-shrink-0">
                                                        {venueData.image && (<img
                                                            className="max-h-20 flex-shrink-0 rounded-l bg-gray-300"
                                                            src={'https://promogogo.com/cdn-cgi/image/fit=pad,width=768/' + venueData.image}
                                                            alt=""/>)}
                                                    </div>
                                                    <div className="min-w-0 flex-1 pt-2 pb-2">
                                                        <div className="focus:outline-none">
                                                            <span className="absolute inset-0" aria-hidden="true"/>
                                                            <p className="text-md font-medium text-gray-900">{venueData.name}</p>
                                                            <p className="truncate text-sm text-gray-500">Street: {venueData.address && venueData.address.streetAddress} </p>
                                                            <p className="truncate text-sm text-gray-500">City: {venueData.address && venueData.address.addressLocality}</p>
                                                            <p className="truncate text-sm text-gray-500">Region: {venueData.address && venueData.address.addressRegion}</p>
                                                            <p className="truncate text-sm text-gray-500">Country: {venueData.address && venueData.address.addressCountry}</p>
                                                            <p className="truncate text-sm text-gray-500">TimeZone: {venueData.address && venueData.address.timezone}</p>

                                                        </div>
                                                    </div>

                                                    <ChevronRightIcon className="h-5 w-5 flex-none text-gray-400"
                                                                      aria-hidden="true"/>

                                                </a>
                                                <div id="geocoder" className="geocoder"></div>
                                                <div className={'mt-4 h-96'} id={'map'}></div>

                                            </div>
                                            <div className=" px-4 sm:mt-16 sm:px-0 lg:mt-4"
                                                 onClick={(event) => clickedEvent(event)}>
                                                {audienceButtons(venueData)}
                                            </div>
                                            <div className=" px-4 sm:mt-16 sm:px-0 lg:mt-0 ">
                                                <section aria-labelledby="details-heading" className="mt-12">

                                                    <div>
                                                        <h3 className={'text-2xl font-bold tracking-tight text-gray-900'}>Upcoming
                                                            events</h3>
                                                        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                                                            {eventList.map((event, index) => (<div key={event['@id']}>
                                                                {smallEventCard(event)}
                                                            </div>))}

                                                        </div>


                                                        <div
                                                                className="grid grid-cols-1 gap-4 sm:grid-cols-1 md:grid-cols-2">
                                                            {artists && artists.map((artist, index) => (<>
                                                                {smallArtistCard(artist)}
                                                            </>))}

                                                        </div>
                                                        <div className="px-4 sm:px-6 lg:px-8 mt-2">
                                                            <div className="sm:flex sm:items-center">


                                                            </div>

                                                        </div>
                                                    </div>
                                                </section>

                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>
                        </div>
                        <div className="col-span-1">

                            <div className=" px-4 mt-4 sm:px-0 mr-2">
                                <div className="col-span-1 min-h-32 bg-gray-100 flex items-end"
                                     onClick={() => toggleMedia()}>

                                    {venueData && venueData.image &&
                                     <div>{imagePad(venueData.image)}</div>}



                                </div>
                                {showMedia && <div onClick={(event) => clickedEvent(event)}><MediaCollection wide={false}
                                                                                                             target={'mediaSelected'}/></div>}
                                <div>
                                    <button
                                        onClick={() => toggleMedia()}
                                        className="relative inline-flex items-center rounded bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10">
                                        Images
                                    </button>
                                </div>
                            </div>
                            {venueData && metaDataLinks(venueData)}
                            {venueData && data.isAdmin && <div className={'mt-2'}><ListActionItems eventid={null} artistid={null} venueid={venueData['@id']}/></div>}

                        </div>
                    </div>
                </main>
                <footer className="bg-white" aria-labelledby="footer-heading">
                    <h2 id="footer-heading" className="sr-only">
                        Footer
                    </h2>

                </footer>
            </div>
            <ToastContainer autoClose={800} theme={'dark'}/>
        </div>)
}
